import React, { FC, LegacyRef } from 'react'
// components
import { OldButton } from 'components/Button'
import { Button } from 'components/ui/Button'
// types
import { Classes } from 'jss'
import { ButtonTypes } from 'types/common'
import { NotificationTypeT } from 'domain/constants'
import { NotificationsListType } from 'pages/Notifications/types'
// styles
import { sheet } from './sheet'
import injectSheet from 'react-jss'
// utils
import { notificationsStructure } from 'pages/Notifications/notificationsStructure'

interface Props {
  classes: Classes
  notifications: NotificationsListType
  notificationsTypes: NotificationTypeT
  setWrapperRef: LegacyRef<HTMLDivElement>
  countUnreadNotifications: number
  toggleNotificationsMenu: () => void
  role: string
}
const Menu: FC<Props> = ({
  classes,
  setWrapperRef,
  notifications,
  notificationsTypes,
  role,
  countUnreadNotifications,
  toggleNotificationsMenu
}) => {
  const list =
    notifications && !notifications.isEmpty() && notifications.size > 7
      ? notifications.take(7)
      : notifications
  return (
    <div className={classes.root} ref={setWrapperRef} onClick={toggleNotificationsMenu}>
      <p className={classes.title}>
        Unread Notifications<span>{countUnreadNotifications}</span>
      </p>
      <Button
        label="VIEW ALL"
        variant="text"
        color="primary"
        fill
        size="md"
        to={`/notifications`}
      />
      {list &&
        !list.isEmpty() &&
        list.map((item, i: number) => (
          <div key={i}>{notificationsStructure(item, notificationsTypes, role, true)}</div>
        ))}
      <Button
        label="VIEW ALL"
        variant="text"
        color="primary"
        fill
        size="md"
        to={`/notifications`}
      />
    </div>
  )
}

export default injectSheet(sheet)(Menu)
